import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
   // tslint:disable-next-line:directive-selector
   selector: 'am-involvement-entity-listing'
})
export class InvolvementEntityListingUpgradeDirective extends UpgradeComponent {
   @Input() involvementId: string;
   @Output() refresh: EventEmitter<any>;

   constructor(elementRef: ElementRef, injector: Injector) {
      super('ceInvolvementEntityListing', elementRef, injector);
   }
}
